// extracted by extract-css-chunks-webpack-plugin
module.exports = {"boxItemsContainer":"_3vEfX-","boxLink":"_201hKa","boxItem":"_1FbOU-","boxIcon":"vkw0VV","boxTitle":"_1Z8vkY"};